package com.kanati.admin.features.readiness

import androidx.compose.runtime.*
import com.kanati.admin.api.AdminApiClient
import com.kanati.admin.components.*
import com.kanati.admin.state.MaterialThemePalette
import com.kanati.admin.state.ReadState
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun ReadinessPanel(apiClient: AdminApiClient, theme: MaterialThemePalette) {
    val state = remember(apiClient) { ReadState<ReadinessAssessment>() }
    val scope = rememberCoroutineScope()
    suspend fun refresh() = state.refresh("Readiness unknown. The backend assessment could not be loaded or understood. Check connectivity and access, then refresh.") {
        apiClient.getGameNightReadiness()
    }
    LaunchedEffect(apiClient) { refresh() }
    SectionCard("Game-night readiness", theme, description = "Deployment configuration · applies to all schools on this backend.", headerActions = {
        ActionButton(if (state.loading) "Refreshing..." else "Refresh readiness", { scope.launch { refresh() } }, theme, isDisabled = state.loading, isPrimary = false)
    }) {
        P { Text("Configuration checks only. Confirm a real report, gate scan, and payment on the intended devices before gates open.") }
        if (state.loading) StatusBanner("Checking backend readiness...", theme)
        state.error?.let { StatusBanner(it, theme, BannerTone.Error) }
        state.value?.let { assessment ->
            StatusBanner(if (assessment.ready) "PASS · Backend reports game-night configuration ready." else "FAIL · Backend reports required configuration is not ready.", theme, if (assessment.ready) BannerTone.Success else BannerTone.Error)
            P { Text("Backend assessment time: ${assessment.generatedAt}") }
            Div({ style { property("display", "grid"); property("grid-template-columns", "repeat(auto-fit, minmax(min(100%, 280px), 1fr))"); gap(10.px) } }) {
            assessment.checks.forEach { check ->
                StatusBanner(buildString {
                    append("${check.state} · ${check.label}\n${check.message}")
                    check.diagnostics.forEach { append("\n$it") }
                }, theme, when (check.state) { "PASS" -> BannerTone.Success; "FAIL" -> BannerTone.Error; else -> BannerTone.Info })
            }
            }
        }
        P { Text("Online admission only. If validation is unavailable, pause admission. Card configuration failures do not invalidate issued tickets; POS cash sales still require the backend. Readiness does not verify offline support.") }
    }
}
